import { render, staticRenderFns } from "./question-mark.vue?vue&type=template&id=6ece5049&scoped=true&"
import script from "./question-mark.vue?vue&type=script&lang=js&"
export * from "./question-mark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ece5049",
  null
  
)

export default component.exports